<script>
  import { link } from "svelte-spa-router";
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import config from "../../stores/config";
  import * as ls from "local-storage";
  import RateModal from "./Utils/RateModal.svelte";

  export let _id;
  export let name;
  export let price;
  export let inventoryLevel;
  export let SKU;
  export let size;
  export let materialReq;

  let showRateModal = false;

  let mult = (a, b) => {
    let result = Number.parseFloat(a) * Number.parseFloat(b);
    return result.toFixed(2);
  };

  onMount(() => {});

  const dispatch = createEventDispatcher();

  const handleDelete = async () => {
    let resItem = await axios.get(
      `${$config.backendURL}/orders/with-style/${_id}`,
      { headers: { authorization: ls.get("jwt") } }
    );

    let usedIn = resItem?.data?.usedIn;

    if (usedIn) {
      alert(
        `${name} is being used in the Orders database.\n\nYou cannot delete this record at the moment!`
      );
      return;
    }

    let confirmDelete = confirm(`Do you wish to delete ${name}?`);

    if (confirmDelete) {
      axios
        .delete(`${$config.backendURL}/fstyles/${_id}`, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          dispatch("delete");
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };

  const handleAdd = () => {
    let qty = prompt(`Enter the quantity to add to stock. Example. 20`);
    qty = qty.replaceAll(/[^\d.-]/g, "");

    axios
      .put(
        `${$config.backendURL}/fstyles/increment/${_id}`,
        { qty },
        {
          headers: { authorization: ls.get("jwt") },
        }
      )
      .then((res) => {
        window.location.reload();
        dispatch("delete");
      })
      .catch((err) => {
        console.log(err);
        alert(err);
      });
  };
</script>

<div class="tr tracking-wider border-b border-gray-100 ">
  <div
    style="min-width: 18.25rem; max-width: 18.25rem;"
    class="flex items-center"
  >
    <button class="text-base btn btn-red-outline mr-2" on:click={handleDelete}>
      <i class="fas fa-trash" />
    </button>
    <a
      href={`/fstyles/${_id}`}
      use:link
      class="text-base btn btn-gray-outline mr-2"
    >
      <i class="fas fa-eye" />
    </a>
    <button class="text-base btn btn-green-outline mr-2" on:click={handleAdd}>
      <i class="fas fa-plus" />
    </button>
    {#if materialReq?.length > 0}
      <button
        class="btn btn-secondary mr-2 text-sm uppercase tracking-wider"
        on:click={() => (showRateModal = true)}
      >
        <i class="fas fa-check-circle mr-2 text-green-500 text-base" />
        Rating
      </button>
    {:else}
      <button
        class="btn btn-secondary mr-2 text-sm uppercase tracking-wider"
        on:click={() => (showRateModal = true)}
      >
        <i class="fas fa-exclamation-circle mr-2 text-red-400 text-base" />
        Rating
      </button>
    {/if}
  </div>
  <div style="min-width: 20rem; max-width: 20rem;">{name}</div>
  <div style="min-width: 7.5rem; max-width: 7.5rem;">
    R{price}
  </div>
  <div style="min-width: 8rem; max-width: 8rem;" class="mr-4">
    {#if materialReq?.length > 0}
      R{materialReq.reduce((sum, el) => sum + el.qtyReq * el.uPrice, 0)}
    {:else}
      <div class="flex items-center justify-start">
        <div
          class="text-xs px-2 py-1 flex items-center bg-gray-500 text-white rounded-md"
        >
          <i class="fas fa-exclamation-triangle mr-1" />
          No rating set
        </div>
      </div>
    {/if}
  </div>
  <div style="min-width: 7.5rem; max-width: 7.5rem;">
    {inventoryLevel}
  </div>
  <div style="min-width: 7.5rem; max-width: 7.5rem;">
    {size}
  </div>
  <div style="min-width: 10rem; max-width: 10rem;">{SKU}</div>
  <div style="min-width: 7.5rem; max-width: 7.5rem;">
    R{mult(inventoryLevel, price)}
  </div>
</div>

<RateModal
  title={name}
  show={showRateModal}
  styleID={_id}
  on:modalClose={() => {
    showRateModal = false;
    window.location.reload();
  }}
/>

<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 10px 20px;
  }
</style>
